/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ListSupplierOrders$Params {
  SupplierName?: string;
  VenueId?: string;
}

export function listSupplierOrders(http: HttpClient, rootUrl: string, params?: ListSupplierOrders$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, listSupplierOrders.PATH, 'get');
  if (params) {
    rb.query('SupplierName', params.SupplierName, {});
    rb.query('VenueId', params.VenueId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

listSupplierOrders.PATH = '/api/mng/Supply/listsupplierorders';
